<template>
    <Overlay :show="showDialog" :opacity="0" @click="Close()"/>
    <div class="information-dialog">
        <img class="btn button-information margin-l" :src="buttonIconSource" :alt="`Information - ${name}`" :title="`Information - ${name}`" :width="size" :height="size" @click="Toggle()"/>
        <div class="dialog-content" v-if="showDialog">
            <div class="flex">
                <slot/>
                <img class="btn close" src="@/assets/Images/Close.png" alt="Close" title="Close" width="20" height="20" @click="Close()"/>
            </div>
        </div>
    </div>
</template>

<script>
import Overlay from "@/components/Overlay.vue";

export default {
    name: "InformationDialog",
    props: {
        buttonIconSource: String,
        size: Number,
        name: String,
        showDialog: Boolean
    },
    components: { Overlay },
    methods: {
        Toggle: function() {
            this.$emit("toggle", {
                showDialog: this.showDialog,
                priority: this.name
            });
        },
        Close: function() { this.$emit("close"); }
    },
    emits: [
        "toggle",
        "close"
    ]
};
</script>